import {
    PRICING_ADD_PRICING,
    PRICING_GET_PRICING,
    PRICING_UPDATE_PRICING,
    PRICING_DELETE_PRICING,
} from "../actions/pricing";

import {
    API_BASE_URL,
    PRICING_ADD_PRICING_URL,
    PRICING_GET_PRICING_URL,
    PRICING_UPDATE_PRICING_URL,
    PRICING_DELETE_PRICING_URL,
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [PRICING_ADD_PRICING]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PRICING_ADD_PRICING_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PRICING_GET_PRICING]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PRICING_GET_PRICING_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PRICING_UPDATE_PRICING]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PRICING_UPDATE_PRICING_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [PRICING_DELETE_PRICING]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + PRICING_DELETE_PRICING_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
};


export default {
    mutations,
    actions,
    getters,
    state
};